module.exports = __webpack_public_path__ + "img/fakecorporate.9d3f71a3.jpg";